import { GlSprintf, GlLink } from '@gitlab/ui';
import { s__ } from '~/locale';
import { PUSH_EVENT_REF_TYPE_BRANCH, PUSH_EVENT_REF_TYPE_TAG, VARIANT_DEFAULT } from '../../constants';
import { isValidVariant } from '../../utils';
import ResourceParentLink from '../resource_parent_link.vue';
import ContributionEventBase from './contribution_event_base.vue';
export default {
    name: 'ContributionEventPushed',
    i18n: {
        new: {
            [PUSH_EVENT_REF_TYPE_BRANCH]: s__('ContributionEvent|Pushed a new branch %{refLink} in %{resourceParentLink}.'),
            [PUSH_EVENT_REF_TYPE_TAG]: s__('ContributionEvent|Pushed a new tag %{refLink} in %{resourceParentLink}.')
        },
        removed: {
            [PUSH_EVENT_REF_TYPE_BRANCH]: s__('ContributionEvent|Deleted branch %{refLink} in %{resourceParentLink}.'),
            [PUSH_EVENT_REF_TYPE_TAG]: s__('ContributionEvent|Deleted tag %{refLink} in %{resourceParentLink}.')
        },
        pushed: {
            [PUSH_EVENT_REF_TYPE_BRANCH]: s__('ContributionEvent|Pushed to branch %{refLink} in %{resourceParentLink}.'),
            [PUSH_EVENT_REF_TYPE_TAG]: s__('ContributionEvent|Pushed to tag %{refLink} in %{resourceParentLink}.')
        },
        multipleCommits: s__('ContributionEvent|…and %{count} more commits. %{linkStart}Compare%{linkEnd}.')
    },
    components: {
        ContributionEventBase,
        GlSprintf,
        GlLink,
        ResourceParentLink
    },
    props: {
        event: {
            type: Object,
            required: true
        },
        variant: {
            type: String,
            required: false,
            default: VARIANT_DEFAULT,
            validator: isValidVariant
        }
    },
    computed: {
        ref () {
            return this.event.ref;
        },
        commit () {
            return this.event.commit;
        },
        message () {
            if (this.ref.is_new) {
                return this.$options.i18n.new[this.ref.type];
            }
            if (this.ref.is_removed) {
                return this.$options.i18n.removed[this.ref.type];
            }
            return this.$options.i18n.pushed[this.ref.type];
        },
        iconName () {
            if (this.ref.is_removed) {
                return 'remove';
            }
            return 'commit';
        },
        hasMultipleCommits () {
            return this.commit.count > 1;
        }
    }
};
